// Utility to construct Backblaze B2 bucket URLs for static assets
const BUCKET_URL = process.env.REACT_APP_BUCKET_URL;

/**
 * Get the full URL for a file in the Backblaze bucket
 * @param {string} path - Path relative to bucket root (e.g., 'photos/IMG_8825.jpeg' or 'logos/honda.svg')
 * @returns {string} Full URL to the bucket file
 */
export function getBucketUrl(path) {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${BUCKET_URL}/${cleanPath}`;
}

/**
 * Get URL for a photo
 * @param {string} filename - Photo filename (e.g., 'IMG_8825.jpeg')
 * @returns {string} Full URL to the photo
 */
export function getPhotoUrl(filename) {
  return getBucketUrl(`photos/${filename}`);
}

/**
 * Get URL for a logo
 * @param {string} filename - Logo filename (e.g., 'honda.svg')
 * @returns {string} Full URL to the logo
 */
export function getLogoUrl(filename) {
  return getBucketUrl(`logos/${filename}`);
}

export default getBucketUrl;
